import { render, staticRenderFns } from "./babsDetayBelgeCellRenderer.vue?vue&type=template&id=05433c1d&"
import script from "./babsDetayBelgeCellRenderer.vue?vue&type=script&lang=js&"
export * from "./babsDetayBelgeCellRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports